import 'css/src/components/common/HeaderLogo';

import React from 'react';

import { Urls } from 'js/src/client';

const HeaderLogo = React.memo(function HeaderLogo() {
    return (
        <a
            className="header-logo p-l5-0"
            href={SERVER.USER ? Urls.DASHBOARD : Urls.HOME}
            target={SERVER.USER ? '' : '_blank'}
            rel="noreferrer"
        >
            <img
                src="https://cdn.lumen5.com/lumen5-site-images/L5-logo/2024/Lumen5-PrimaryLogo.svg"
                alt="Lumen5 logo"
                height="28"
            />
        </a>
    );
});

export default HeaderLogo;
